<template>
  <button class="button" :class="[color]" :disabled="disabled" @click="onClick">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: ["color", "disabled"],
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style scoped>
.button {
  display: inline-block;
  padding: 0.2rem 0.8rem;
  border: 1px solid transparent;
  border-radius: 1rem;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.button:hover {
  background-color: #f8f9fa;
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.primary:hover {
  background-color: #0069d9;
  border-color: #0062cc;
}

.primary:disabled {
  background-color: #fff;
  border-color: #007bff;
  color: #007bff;
}

.secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}

.secondary:disabled {
  background-color: #fff;
  border-color: #6c757d;
  color: #6c757d;
}

.success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.success:hover {
  background-color: #218838;
  border-color: #1e7e34;
}

.success:disabled {
  background-color: #fff;
  border-color: #28a745;
  color: #28a745;
}

.danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.danger:hover {
  background-color: #c82333;
  border-color: #bd2130;
}

.danger:disabled {
  background-color: #fff;
  border-color: #dc3545;
  color: #dc3545;
}

.warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}

.warning:hover {
  background-color: #e0a800;
  border-color: #d39e00;
}

.warning:disabled {
  background-color: #212529;
  border-color: #ffc107;
  color: #ffc107;
}

.info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.info:hover {
  background-color: #138496;
  border-color: #117a8b;
}

.info:disabled {
  background-color: #fff;
  border-color: #17a2b8;
  color: #17a2b8;
}

.light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}

.light:hover {
  background-color: #e2e6ea;
  border-color: #dae0e5;
}

.light:disabled {
  background-color: #212529;
  border-color: #f8f9fa;
  color: #f8f9fa;
}

.dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.dark:hover {
  background-color: #23272b;
  border-color: #1d2124;
}

.dark:disabled {
  background-color: #fff;
  border-color: #343a40;
  color: #343a40;
}
</style>
